import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { createInventoriesAction } from '../../../store/inventory'
import { Form, Input } from 'antd'
import { OPERATION_DISPOSAL } from '../constants'
import InventoryOperationModalForm from './InventoryOperationModalForm'

const { TextArea } = Input

const DisposalInventoryOperationModal = ({ equipmentIds, showModal, onCancel, onFinish }) => {
  const dispatch = useDispatch()

  const onFinishAction = useCallback(
    async (data) => {
      let result = await dispatch(
        createInventoriesAction({
          ...data,
          type: OPERATION_DISPOSAL,
          equipments: equipmentIds,
        })
      ).unwrap()
      onFinish(equipmentIds)
      return result
    },
    [dispatch, equipmentIds]
  )

  return (
    <InventoryOperationModalForm
      title="Карточка операции ликвидации"
      formName="disposal-inventory-operation"
      messageKey="disposal_inventory"
      showModal={showModal}
      onFinish={onFinishAction}
      onCancel={onCancel}
    >
      <Form.Item name="comment" label="Комментарий" labelCol={{ span: 24 }}>
        <TextArea rows={4} />
      </Form.Item>
    </InventoryOperationModalForm>
  )
}

export default DisposalInventoryOperationModal
